var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeafHeaderFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 396.28 638.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -182.91,
    y1: -221.4,
    x2: 526.46,
    y2: 799.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#00b1c8",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.2,362.74c.17,1.55-.08,3.3,0,4.9s-.62,4.07.98,4.9c1.26,63.8-9.18,104.46-59.37,146.13-2.67,2.21-16.22,13.23-18.41,12.67-1.68-.43-20.95-22.15-23.76-25.38-54.92-63.34-79.43-121.14-116.73-194.21-.58-1.13-.91-2.71-2.43-2.96,5.3,28.44,16.52,56.68,28.26,83.06,32.91,73.95,82.66,145.51,137.98,204.35,4.14,4.4,31.37,29.73,31.86,31.93.31,1.39-8.75,7.27-10.44,8.09-6.49,3.16-7.72,3.27-12.58-1.78-24.98-25.88-48.47-53.3-69.81-82.29-71.41,13.99-134.14-7.73-182.28-60.92-43.76-48.35-72.24-108.31-86.79-171.67C-10.58,222.68,1.53,128.67,26.66,33.93c2.57-9.68,5.23-22.63,8.55-31.67.3-.83.38-2.07,1.43-2.27,24.6,7.73,49.11,15.93,72.8,26.12,129.93,55.93,269.35,189.77,285.76,336.62Z",
    style: {
      fill: "url(#linear-gradient)",
      fillOpacity: 0.6,
      isolation: "isolate",
      opacity: 0.6
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafHeaderFull);
export default __webpack_public_path__ + "static/media/leaf-header-full.c65ba9454b029ddb8ea1347bd42b467a.svg";
export { ForwardRef as ReactComponent };